import * as yup from 'yup'

const REGEX_PHONE_NUMBER = /^0(\d{9,10})$/
const REGEX_PASSWORD = /^[a-zA-Z0-9_.-]{8,}$/

function checkPhoneNumber(message) {
  return this.matches(REGEX_PHONE_NUMBER, {
    message: message,
    excludeEmptyString: true
  });
}

function password(message) {
  return this.matches(REGEX_PASSWORD, {
    message: message,
    excludeEmptyString: true
  });
}

yup.addMethod(yup.string, 'phoneNumber', checkPhoneNumber);
yup.addMethod(yup.string, 'password', password);

export default yup
